import JoiImport from 'joi';
import joiDate from '@joi/date';

const Joi = JoiImport.extend(joiDate);

const isValidJsonString = string => {
  try {
    JSON.parse(string);
    return true;
  } catch (e) {
    return false;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const recommendationCsvValidationSchema = Joi.array().items(
  Joi.object().keys({
    name: Joi.string().required(),
    date: Joi.date().format('M/D/YYYY'),
    email: Joi.string().email({ tlds: false }),
    skills: Joi.string().custom(value => {
      const valueWithBracket = `[${value}]`;
      if (isValidJsonString(valueWithBracket)) {
        return true;
      }
      throw new Error('Invalid JSON format');
    }),
    ['company name']: Joi.string().allow(''),
    ['send count']: Joi.number().min(1),
    token: Joi.string().allow(''),
    ['template id']: Joi.number().min(1),
  }),
);

export const jdRecommendationCsvValidationSchema = Joi.array().items(
  Joi.object().keys({
    name: Joi.string().required(),
    email: Joi.string().email({ tlds: false }),
    ['job name']: Joi.string().required(),
    ['job description']: Joi.string().required(),
    ['job url']: Joi.string().required(),
    ['company name']: Joi.string().required(),
    ['send count']: Joi.number().min(1),
    ['template id']: Joi.number().min(1),
  }),
);
